export enum LANG {
  RU = 'ru',
  EN = 'en',
  ES = 'es',
  HI = 'hi',
  PT = 'pt',
  TR = 'tr',
  UK = 'uk',
  ZH = 'zh',
  FI = 'fi',
  FR = 'fr',
  EL = 'el',
  HU = 'hu',
  IT = 'it',
  SV = 'sv',
  SW = 'sw',
  SL = 'sl',
  SK = 'sk',
  RO = 'ro',
  PL = 'pl',
  NB = 'nb',
  LT = 'lt',
  LV = 'lv',
  KO = 'ko',
  JA = 'ja',
  ID = 'id',
  DE = 'de',
  ET = 'et',
  NL = 'nl',
  DA = 'da',
  CS = 'cs',
  BG = 'bg',
  BN = 'bn',
  BE = 'be',
  AR = 'ar',
  VI = 'vi',
}